import { Typography } from '@mui/material';
import { concat } from 'lodash';
import React, { FC } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import MUIAlert from 'src/components/ui-component/mui-alert/MUIAlert';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import { InhaltWrapper } from 'src/pages/private/online-antrag/antrag-components/Wrapper';
import ApplicationHeading from 'src/pages/private/online-antrag/application-heading/ApplicationHeading';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const ProjektbewertungEPZ: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);
	return (
		<>
			<ApplicationHeading title='Zielindikatoren, Monitoring, Projektfortschritts- und Erfolgskontrolle' description={PLATZHALTER_TEXT} />
			<InhaltWrapper marginTop='0'>
				<Typography>
					Welche Maßnahmen werden durchgeführt, um den Projektfortschritt zu erfassen? Welche Zielindikatoren werden definiert, um die
					Zielerreichung zu messen? Im Verwendungsnachweis ist der Erfolg des Projekts auszuwerten.
				</Typography>
				<Typography>
					Ein Indikator ist eine empirisch messbare Größe, die es ermöglicht, Ergebnisse und Wirkungen zu operationalisieren, sodass für alle
					Projektbeteiligten Konsens darüber hergestellt ist, was erreicht werden soll und in welchem Bereich Handlungsbedarf besteht.
					Indikatoren dienen der Bewertung von Ergebnissen und Wirkungen von Projektmaßnahmen. Bei der Entwicklung von Indikatoren sind folgende
					Prüffragen zu beantworten: Was wird gemessen? Wie wird es gemessen? Was ist der Beitrag zum übergeordneten Projektziel?
				</Typography>

				<Typography>
					Ist der Indikator spezifisch, messbar, kosteneffizient ermittelbar, für das Programm relevant und wird zeitnah verfügbar sein (s. m. a.
					r. t.)?
				</Typography>
				<MUIAlert
					infoType={'info'}
					title='Beispiele für Indikatoren:'
					message={
						<>
							<ul>
								<li>
									X% der Kleinbäuerinnen und -bauern (davon mind. X% Frauen, mind. Y% Haushalte mit Menschen mit Behinderung…) haben bis zum
									[Zeitpunkt Z] ihre Erträge von Grundnahrungsmitteln durchschnittlich gesteigert.
								</li>
								<li>
									{' '}
									X% der Teilnehmenden an [Maßnahme X], davon [X] % Frauen, bestätigen zum [Zeitpunkt Z], dass sich ihre Einstellung
									gegenüber der jeweils anderen Gruppe positiv verändert hat.
								</li>
								<li>
									Bis zum [Zeitpunkt Z] wurden [Anzahl X] der Begünstigten, davon [Anzahl Y] Frauen, in XY geschult/unterrichtet oder haben
									an XY teilgenommen.
								</li>
							</ul>
						</>
					}
				/>
			</InhaltWrapper>
			<CreateForm formStruc={formStruc()} formValues={application} updateFormValuesFunc={setApplicationProperty} readOnly={updatedReadOnly} />
		</>
	);
};

export default ProjektbewertungEPZ;

const formStruc = () => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				{
					...P.Projektbeschreibung_Entwicklungszusammenarbeit.schema.attributes.Projektfortschritt_Erfolgskontrolle_Monitoring,
					maxCharLength: 2000,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};

export const getFormStrucProjektbewertungEPZ = (_application: any) => {
	return concat(formStruc());
};
